      <section class="decision-detail__section decision-detail__section--collapsible" *ngIf="decision.evidence.length" #evidenceSection tabindex="-1" [attr.data-highlight]="view.highlightedSection === 'evidence' ? 'true' : null">
        <button
          type="button"
          class="decision-detail__section-toggle"
          (click)="view.toggleSection('evidence')"
          [attr.aria-expanded]="view.isSectionExpanded('evidence')"
        >
          <span class="decision-detail__section-toggle-copy">
            <span class="decision-detail__section-label">{{ view.lang.translate('home.decisionDetail.evidence') }}</span>
          </span>
          <span class="decision-detail__section-toggle-meta">
            <span class="decision-detail__section-count">{{ decision.evidence.length }}</span>
            <i class="fa" [class.fa-chevron-down]="!view.isSectionExpanded('evidence')" [class.fa-chevron-up]="view.isSectionExpanded('evidence')" aria-hidden="true"></i>
          </span>
        </button>

        <div class="decision-detail__section-body" *ngIf="view.isSectionExpanded('evidence')">
          <ul class="decision-detail__stack">
            <li class="decision-detail__stack-item" *ngFor="let evidence of decision.evidence | slice: 0:4">
              <p class="decision-detail__stack-title">{{ view.translateEvidenceLabel(evidence) }}</p>
              <p class="decision-detail__stack-copy">{{ view.translateEvidenceValue(evidence) }}</p>
            </li>
          </ul>
        </div>
      </section>

      <section class="decision-detail__section decision-detail__section--collapsible" *ngIf="decision.missingInformation.length" #missingInformationSection tabindex="-1" [attr.data-highlight]="view.highlightedSection === 'missing' ? 'true' : null">
        <button
          type="button"
          class="decision-detail__section-toggle"
          (click)="view.toggleSection('missing')"
          [attr.aria-expanded]="view.isSectionExpanded('missing')"
        >
          <span class="decision-detail__section-toggle-copy">
            <span class="decision-detail__section-label">{{ view.lang.translate('home.decisionDetail.missingInformation') }}</span>
          </span>
          <span class="decision-detail__section-toggle-meta">
            <span class="decision-detail__section-count">{{ decision.missingInformation.length }}</span>
            <i class="fa" [class.fa-chevron-down]="!view.isSectionExpanded('missing')" [class.fa-chevron-up]="view.isSectionExpanded('missing')" aria-hidden="true"></i>
          </span>
        </button>

        <div class="decision-detail__section-body" *ngIf="view.isSectionExpanded('missing')">
          <ul class="decision-detail__stack">
            <li class="decision-detail__stack-item" *ngFor="let item of view.missingInformationDisplays | slice: 0:4">
              <p class="decision-detail__stack-title">{{ item.label }}</p>
              <p class="decision-detail__stack-copy">{{ item.blockingReason }}</p>
              <div class="decision-detail__missing-meta">
                <p class="decision-detail__missing-label">{{ view.lang.translate('home.decisionDetail.missingLocation') }}</p>
                <p class="decision-detail__missing-value">{{ item.resolutionLocationLabel }}</p>
              </div>
              <p class="decision-detail__missing-copy">{{ item.resolutionCopy }}</p>
              <p class="decision-detail__missing-copy">{{ item.externalResolutionCopy }}</p>
              <p class="decision-detail__missing-copy">{{ item.nextStepCopy }}</p>
            </li>
          </ul>
        </div>
      </section>

      <section class="decision-detail__section decision-detail__section--collapsible" *ngIf="view.hasSourceTrace" #sourceTraceSection tabindex="-1" [attr.data-highlight]="view.highlightedSection === 'technical' ? 'true' : null">
        <button
          type="button"
          class="decision-detail__section-toggle"
          (click)="view.toggleSection('technical')"
          [attr.aria-expanded]="view.isSectionExpanded('technical')"
        >
          <span class="decision-detail__section-toggle-copy">
            <span class="decision-detail__section-label">{{ view.technicalTraceToggleLabel }}</span>
          </span>
          <span class="decision-detail__section-toggle-meta">
            <span class="decision-detail__section-count">{{ view.technicalEntries.length }}</span>
            <i class="fa" [class.fa-chevron-down]="!view.isSectionExpanded('technical')" [class.fa-chevron-up]="view.isSectionExpanded('technical')" aria-hidden="true"></i>
          </span>
        </button>

        <div class="decision-detail__section-body" *ngIf="view.isSectionExpanded('technical')">
          <p class="decision-detail__technical-copy">{{ view.lang.translate('home.decisionDetail.technical.copy') }}</p>
          <dl class="decision-detail__trace-grid">
            <div
              *ngFor="let entry of view.technicalEntryDisplays"
              class="decision-detail__trace-entry"
              [class.decision-detail__trace-entry--multiline]="entry.multiline"
            >
              <dt>{{ entry.label }}</dt>
              <dd
                class="decision-detail__trace-value"
                [class.decision-detail__trace-value--multiline]="entry.multiline"
              >{{ entry.value }}</dd>
            </div>
          </dl>
        </div>
      </section>

      <section class="decision-detail__section decision-detail__section--collapsible" *ngIf="view.detail?.activityPreview?.length">
        <button
          type="button"
          class="decision-detail__section-toggle"
          (click)="view.toggleSection('history')"
          [attr.aria-expanded]="view.isSectionExpanded('history')"
        >
          <span class="decision-detail__section-toggle-copy">
            <span class="decision-detail__section-label">{{ view.lang.translate('home.decisionDetail.historyPreview') }}</span>
          </span>
          <span class="decision-detail__section-toggle-meta">
            <span class="decision-detail__section-count">{{ view.detail?.activityPreview?.length }}</span>
            <i class="fa" [class.fa-chevron-down]="!view.isSectionExpanded('history')" [class.fa-chevron-up]="view.isSectionExpanded('history')" aria-hidden="true"></i>
          </span>
        </button>

        <div class="decision-detail__section-body" *ngIf="view.isSectionExpanded('history')">
          <ul class="decision-detail__timeline">
            <li class="decision-detail__timeline-item" *ngFor="let activity of view.historyPreviewDisplays | slice: 0:4">
              <div class="decision-detail__timeline-meta">
                <span>{{ activity.title }}</span>
                <span>{{ activity.occurredAt | date: 'short' }}</span>
              </div>
              <p class="decision-detail__timeline-copy">{{ activity.narrative }}</p>
            </li>
          </ul>
        </div>
      </section>

      <section class="decision-detail__section decision-detail__section--collapsible" *ngIf="decision.documents.length">
        <button
          type="button"
          class="decision-detail__section-toggle"
          (click)="view.toggleSection('documents')"
          [attr.aria-expanded]="view.isSectionExpanded('documents')"
        >
          <span class="decision-detail__section-toggle-copy">
            <span class="decision-detail__section-label">{{ view.lang.translate('home.decisionDetail.documents') }}</span>
          </span>
          <span class="decision-detail__section-toggle-meta">
            <span class="decision-detail__section-count">{{ decision.documents.length }}</span>
            <i class="fa" [class.fa-chevron-down]="!view.isSectionExpanded('documents')" [class.fa-chevron-up]="view.isSectionExpanded('documents')" aria-hidden="true"></i>
          </span>
        </button>

        <div class="decision-detail__section-body" *ngIf="view.isSectionExpanded('documents')">
          <ul class="decision-detail__documents">
            <li *ngFor="let document of decision.documents">
              <a *ngIf="document.publicUrl; else documentLabel" [href]="document.publicUrl" target="_blank" rel="noopener noreferrer">
                {{ document.title }}
              </a>
              <ng-template #documentLabel>{{ document.title }}</ng-template>
            </li>
          </ul>
        </div>
    </section>
